import { CashFlowPaymentTypeEnum } from '@/services/api-clients';

export function cashFlowPaymentTypeIconFilter(paymentType: CashFlowPaymentTypeEnum) {
  switch (paymentType) {
    case CashFlowPaymentTypeEnum.Cash: return 'mdi-cash';
    case CashFlowPaymentTypeEnum.Transfer: return 'mdi-bank-transfer-in';
    case CashFlowPaymentTypeEnum.AdvancePaymentCash: return 'mdi-briefcase';
    case CashFlowPaymentTypeEnum.AdvancePaymentTransfer: return 'mdi-credit-card';
    default: return '';
  }
}
